import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Layout, Menu } from "antd";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import StorefrontIcon from "@mui/icons-material/Storefront";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import "./AdminMenu.scss";
import BuildIcon from "@mui/icons-material/Build";
import GroupIcon from "@mui/icons-material/Group"; // Icono de grupo
export function AdminMenu(props) {
  const { menuCollapsed } = props;
  const navigate = useNavigate();
  let location = useLocation();
  // eslint-disable-next-line no-unused-vars
  const [classNameTextMenu, setClassNameTextMenu] = useState("");
  const { Sider } = Layout;
  const [current, setCurrent] = useState(location.pathname);

  const onClick = (e) => {
    setCurrent(e.key);

    navigate(e.key);
  };

  useEffect(() => {
    if (menuCollapsed === true) {
      setClassNameTextMenu("nav-text-hidden");
    } else {
      setClassNameTextMenu("nav-text");
    }
  }, [menuCollapsed]);

  const items = [
    {
      label: "Slider",
      key: location.pathname === "/" ? "/" : "/headers",
      icon: (
        <FormatListBulletedOutlinedIcon color="#fff" style={{ fontSize: 25 }} />
      ),
    },
    {
      label: "Categorías",
      key: "/categorias",
      icon: <CategoryOutlinedIcon color="#fff" style={{ fontSize: 25 }} />,
    },

    {
      label: "Productos",
      key: "/productos",
      icon: <StorefrontIcon color="#fff" style={{ fontSize: 25 }} />,
    },
    {
      label: "Servicios",
      key: "/servicios",
      icon: <BuildIcon color="#fff" style={{ fontSize: 25 }} />,
    },
    {
      label: "Clientes",
      key: "/clientes",
      icon: <GroupIcon color="#fff" style={{ fontSize: 25 }} />,
    },
    {
      label: "Configuración",
      key: "/config",
      icon: <SettingsOutlinedIcon color="#fff" style={{ fontSize: 25 }} />,
    },
    // {
    //   label: "Usuarios",
    //   key: "/users",
    //   icon: <GroupOutlinedIcon color="#fff" />,
    // },
  ];

  return (
    <Sider className="admin-sider" collapsed={menuCollapsed}>
      <Menu
        className="menu"
        mode="inline"
        onClick={onClick}
        selectedKeys={[current]}
        items={items}
      ></Menu>
    </Sider>
  );
}
